import React, { memo, useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { getCustomerProfile } from 'src/selectors/customer'
import { CustomerCollectedDataType } from 'src/constants/customer/enums'
import { useNavigate } from 'react-router-dom'
import { FullScreenLoader } from 'src/components/shared/FullScreenLoader'
import { Button } from 'src/components/shared/Button'
import tw from 'twin.macro'
import { ChevronLeftMinor } from '@shopify/polaris-icons'
import { CustomerTSAForm } from 'src/components/customer/customer-tsa-form/CustomerTSAForm'
import { ROUTES } from 'src/constants/routes'

const CustomerResubmitTSAPageComponent = () => {
  const navigate = useNavigate()

  const customerProfile = useSelector(getCustomerProfile)

  const initialValues = useMemo(() => {
    const businessDetails = customerProfile?.collectedData.find(
      (item) => item.type === CustomerCollectedDataType.TSA,
    )?.data

    return {
      isRegisteredAgent: businessDetails?.isRegisteredAgent ? 'yes' : 'no',
      iacNumber: businessDetails?.iacNumber || '',
      dateOfLastCertification: businessDetails?.dateOfLastCertification || '',
      agentName: businessDetails?.agentName || '',
      coordinatorName: businessDetails?.coordinatorName || '',
      coordinatorPhoneNumber: businessDetails?.coordinatorPhoneNumber || '',
      coordinatorEmail: businessDetails?.coordinatorEmail || '',
      hasTwic:
        businessDetails?.hasTwic === true
          ? 'yes'
          : businessDetails?.hasTwic === false
          ? 'no'
          : undefined,
      twicContractorsNumber: businessDetails?.twicContractorsNumber,
      hasFast:
        businessDetails?.hasFast === true
          ? 'yes'
          : businessDetails?.hasFast === false
          ? 'no'
          : undefined,
      fastContractorsNumber: businessDetails?.fastContractorsNumber,
      hasSida:
        businessDetails?.hasSida === true
          ? 'yes'
          : businessDetails?.hasSida === false
          ? 'no'
          : undefined,
      sidaContractorsNumber: businessDetails?.sidaContractorsNumber,
      hasHazmat:
        businessDetails?.hasHazmat === true
          ? 'yes'
          : businessDetails?.hasHazmat === false
          ? 'no'
          : undefined,
      hazmatContractorsNumber: businessDetails?.hazmatContractorsNumber,
    }
  }, [customerProfile?.collectedData])

  const handleBack = useCallback(() => {
    navigate(ROUTES.BASE_URL)
  }, [navigate])

  if (!customerProfile) {
    return <FullScreenLoader />
  }

  return (
    <>
      <CustomerTSAForm initialValues={initialValues} onSubmit={handleBack} />
      <div css={tw`absolute left-4 top-20`}>
        <Button
          onClick={handleBack}
          leftIcon={<ChevronLeftMinor width={20} height={20} fill="white" />}
          size="small"
          color="black"
        >
          Back
        </Button>
      </div>
    </>
  )
}

export const CustomerResubmitTSAPage = memo(CustomerResubmitTSAPageComponent)
